export default class onlyIntegers {
    constructor() {
        return function (scope, element, attrs) {

            element.bind("keydown paste", (event) => {
                let maxVal = +attrs.max;
                if (event.shiftKey) {
                    event.preventDefault();
                    return false;
                }
                // allow enter, ctrl, del, backspace, navigation arrows
                if ([8, 13, 27, 37, 38, 39, 40, 46].indexOf(event.which) > -1) {
                    return true;
                }
                // allow all numbers and numpad
                else if ((event.which >= 48 && event.which <= 57) || (event.which >= 96 && event.which <= 105)) {
                    // prevent event if user have reached max value
                    if (maxVal) {
                        let val = element.val() || '';
                        let increment = event.key;
                        let increasedVal = val + increment;
                        if (+increasedVal > maxVal) {
                            event.preventDefault();
                            return false;
                        }
                    }
                    return true;
                } else {
                    event.preventDefault();
                    return false;
                }
            });
        }
    }
}
